// extracted by mini-css-extract-plugin
module.exports = {"container":"pages_SavedArticlesPage_container","wrapper":"pages_SavedArticlesPage_wrapper","main":"pages_SavedArticlesPage_main","rightRail":"pages_SavedArticlesPage_rightRail"};